import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Dialog, DialogBody,
    Typography,
    Chip
} from "@material-tailwind/react";
import { useState } from 'react';
import { useUserContext } from '../../context';
import { useApi } from '../../hooks/useApi';
import AmountCard from '../../widgets/cards/amount-card';
import { ClockLoader } from 'react-spinners';
import RoomBookingCard from '../../widgets/cards/room-booking-card';


const TABLE_HEAD = ["Hotel", "Card#", "Date", "Status", "Rooms", "Total Amount", "Amount Received", "Discount", "Due", "Due Reason"];

export default function Search() {
    const { fetchAccessToken, assignments } = useUserContext();
    const [isLoading, setIsLoading] = useState(false);
    const [cardsData, setCardsData] = useState([]);
    const { getAllCardsByMobile } = useApi();
    const [mobileNo, setMobileNo] = useState("");

    let getCardsInternal = async () => {
        if (!mobileNo) {
            return;
        }
        setIsLoading(true);
        try {
            const token = await fetchAccessToken();
            let cards = await getAllCardsByMobile(mobileNo, token);

            if (cards && cards.length) {
                setCardsData(cards);
            } else {
                setCardsData([]);
            }
        } catch (ex) {

        } finally {
            setIsLoading(false);
        }
    }

    function getHotelName(hotelId) {
        let hotel = assignments?.hotels.find(hotel => hotel.id.toLowerCase() === hotelId.toLowerCase());
        if (hotel) {
            return hotel.name;
        }
        return "Other Hotel";
    }

    const sortedCardData = [...cardsData].sort((a, b) => a.createdOn - b.createdOn);

    return (
        <div>
            <Card className="h-full w-full">
                <CardHeader variant="gradient" color="gray" className="mt-6 mb-8 p-4">
                    <Typography variant="h6" color="white">
                        Search
                    </Typography>
                </CardHeader>
                <CardBody className="overflow-scroll px-0 pt-0 pb-2">

                    <div className="flex flex-wrap overflow-x-auto px-10">
                        <div className="flex flex-wrap">
                            <Typography variant="h6" className="py-3 px-3">
                                Mobile :
                            </Typography>
                            <input type="tel" id="mobileNo" name="mobileNo"
                                className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring ease-linear transition-all duration-150"
                                value={mobileNo} onChange={(event) => setMobileNo(event.target.value)} />
                            <Button className="rounded-full m-2 ml-3 bg-purple-500 text-white" size="sm" onClick={getCardsInternal}>Search</Button>
                        </div>
                    </div>
                    <table className="mt-0 w-full min-w-max table-auto text-left">
                        <thead>
                            <tr>
                                {TABLE_HEAD.map((head) => (
                                    <th
                                        key={head}
                                        className="border-y border-blue-gray-100 bg-blue-gray-50/50 p-4"
                                    >
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal leading-none opacity-70"
                                        >
                                            {head}
                                        </Typography>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {sortedCardData.map(
                                ({ hotelId, cardNo, createdOn, totalAmount, guestName, guestMobile, paymentDetails, roomDetails, amountDue, discount, status, dueReason, bookingType, reference }, index) => {
                                    const isLast = index === cardsData.length - 1;
                                    const classes = isLast
                                        ? "p-2"
                                        : "p-2 border-b border-blue-gray-50";
                                    return (
                                        <tr key={cardNo}>
                                            <td className={classes}>
                                                <Typography
                                                    variant="small"
                                                    color="blue-gray"
                                                    className="font-normal"
                                                >
                                                    {getHotelName(hotelId)}
                                                </Typography>
                                            </td>
                                            <td className={classes}>
                                                <div className="flex flex-col">
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal"
                                                    >
                                                        {cardNo} ({status})
                                                    </Typography>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-bold opacity-70"
                                                    >
                                                        {guestName}
                                                    </Typography>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal opacity-70"
                                                    >
                                                        <a href={`tel:${guestMobile}`} style={{ textDecoration: 'underline' }}>{guestMobile}</a>
                                                    </Typography>
                                                </div>
                                            </td>
                                            <td className={classes}>
                                                <div className="flex flex-col">
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal"
                                                    >
                                                        {new Date(createdOn).toLocaleString()}
                                                    </Typography>
                                                    {bookingType && <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-bold"
                                                    >
                                                        Type: {bookingType}
                                                    </Typography>
                                                    }
                                                    {reference && <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal"
                                                    >
                                                        Ref: {reference}
                                                    </Typography>
                                                    }
                                                </div>
                                            </td>
                                            <td className={classes}>
                                                <div>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal"
                                                    >
                                                        <Chip
                                                            variant="gradient"
                                                            color={status === "ACTIVE" ? "green" : (status === "PENDING" ? "yellow" : "blue-gray")}
                                                            value={status}
                                                            className="py-0.5 px-2 text-[11px] font-medium w-fit"
                                                        />
                                                    </Typography>
                                                </div>
                                            </td>
                                            <td className={classes}>
                                                <RoomBookingCard roomDetails={roomDetails} />
                                            </td>
                                            <td className={classes}>
                                                <div>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal"
                                                    >
                                                        {totalAmount}.00
                                                    </Typography>
                                                </div>
                                            </td>
                                            <td className={classes}>
                                                <AmountCard payments={paymentDetails} />
                                            </td>
                                            <td className={classes}>
                                                <div>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal"
                                                    >
                                                        {discount ?? "0"}.00
                                                    </Typography>
                                                </div>
                                            </td>
                                            <td className={classes}>
                                                <div>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal"
                                                    >
                                                        {amountDue}.00
                                                    </Typography>
                                                </div>
                                            </td>
                                            <td className={classes}>
                                                <div>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal"
                                                    >
                                                        {dueReason}
                                                    </Typography>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                },
                            )}
                        </tbody>
                    </table>
                </CardBody>
            </Card>
            <Dialog open={isLoading} className="bg-transparent shadow-none" size="md">
                <DialogBody className="bg-transparent shadow-none flex justify-center">
                    <ClockLoader color="#2be60d" />
                </DialogBody>
            </Dialog>
        </div>
    )

}
